<template>
  <v-app>
    <!--編輯-->
    <v-dialog v-model="isVisible"
              no-click-animation
              max-width="90%">
      <v-card>
        <v-card-title>{{getTransactionTitle}}</v-card-title>
        <v-card-text>
          <v-layout row wrap >
            <v-flex xs1 md1 >
              <v-btn color="primary" dark text @click="addData()" >新增</v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap >
            <v-flex>
              <table-view :columnKeys="columnKeys"
                        :items="items"
                        :loading="loading"
                        :total-items="getTotalItems"
                        @cellEvent="cellEvent"
                        @handleLoadData="loadData">
              </table-view>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="primary" dark text @click="confirmEvent">確定</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <BankEditorDialog :visible="bankDialog.visible"
        :item="bankItem"
        @confirmEvent="bankDialog.confirm"
        @closeEvent="bankDialog.cancel"
    ></BankEditorDialog>
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.text"
                :isHtmlContent="true"
                :showCancel="messageDialog.showCancelButton"
                @cancelEvent="messageDialog.cancel"
                @confirmEvent="messageDialog.confirm"></alert-view>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ListEditor from '../components/ListEditor';
import BankEditorDialog from '../components/BankEditorDialog';
import BankInfoModel from '../models/BankInfoModel';
import AlertView from '@/components/AlertView';
import { getNow } from '@/pages/utils/tool';
import TableView from '@/components/TableView';
const bankCodeList = require('../assets/bank_data.json');
export default {
  name: 'BankManageDialog',
  components: {
    TableView,
    BankEditorDialog,
    AlertView
  },
  props: {
    visible: Boolean,
    favorite: Number
  },
  data() {
    return {
      loading: false,
      isNew: false,
      isVisible: false,
      totalItems:0,
      items:[],
      bankItem: new BankInfoModel(),
      bankDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancelButton: false,
        confirm: () => {},
        cancel: () => {},
      }
    };
  },
  created() {

  },
  watch:{
    visible(value){
      this.isVisible = value;
    },
    isVisible(value) {
      if(value) {
        this.loadData()
      } else {
        this.closeEvent()
      }
    }
  },
  mounted () {

  },
  computed:{
    ...mapGetters(['getUserInfo',]),
    getTotalItems() {
      return this.totalItems;
    },
    getTransactionTitle() {
      return this.favorite === 1 ?`常用帳號管理`: `嘉好銀行管理`
    },
    columnKeys() {
      let list = [
        // {
        //   value: "codeName",
        //   text: "代號",
        //   sortable: false,
        //   required: true,
        //   isShow: true,
        //   isEdit: true,
        // },
        {
          value: "title",
          text: "銀行",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
          options: this.getBankInfo(),
          isSelect: true,
        },
        {
          value: "subTitle",
          text: "分行",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
          options: this.getBankSubInfo(),
          isSelect: true,
        },
        {
          value: "name",
          text: "戶名",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "account",
          text: "帳號",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "balance",
          text: "餘額",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        { value: "edit", text: "編輯", sortable: false, required: false , color:'primary', isEvent: true},
        { value: "delete", text: "刪除", sortable: false, required: false , isEvent: true}
      ];
      if(this.favorite === 1) {
        return list.filter(m => m.value !== `balance`)
      }
      return list;
    },
  },
  methods: {
    ...mapActions(["updateBank","createBank","bankInfo","bankList","deleteBank"]),
    getBankInfo(){
      let bankCopyList = JSON.parse(JSON.stringify(bankCodeList));
      let list = [];
      Object.keys(bankCopyList).forEach(key=>{
        const bankInfo = bankCopyList[key];
        const option = {
          key: key,
          text: bankInfo.branch
        };
        list.push(option);
      });
      return list;
    },
    getBankSubInfo(){
      let list = [];
      let bankCopyList = JSON.parse(JSON.stringify(bankCodeList));
      Object.keys(bankCopyList).forEach(key=>{
        const bankInfo = bankCopyList[key];
        bankInfo.child.forEach(info=>{
          const option = {
            key: info.code.substring(3, info.code.length),
            text: `${info.branch}`
          };
          list.push(option);
        });
      });
      return list;
    },
    async loadData() {
      this.loading = true;
      const data = {
        "favorite": this.favorite
      }
      const results = await this.bankList(data)
      this.items = results.data.data.list;
      this.items.forEach(element => {
        element.codeName = `${element.title}-${element.subTitle}-${element.name}`
      });

      this.totalItems = this.items.length || 0 ;
      this.loading = false;
    },
    addData() {
      this.isNew = true;
      let info = new BankInfoModel()
      info.favorite = this.favorite
      this.showBankEditor(info)
    },
    edit(item) {
      this.isNew = false;
      this.showBankEditor(item)
    },
    async info(item) {

      const data = {"bankId" : item.bankId}
      const results = await this.bankInfo(data)

      const result = results.data.data
      let message = `銀行:${result.title}<br>`
      message += `分行: ${result.subTitle}<br>`
      message += `戶名: ${result.name}<br>`
      message += `帳戶: ${result.account}<br>`
      message += `銀行餘額: ${result.balance}<br>`
      // message += `交易時間:${result.transactionDate}<br>`
      // message += `交易金額:${result.price}<br>`
      // message += `銀行餘額:${result.balance}<br>`
      // message += `備註:${result.comment}<br>`
      this.showMessageDialog("交易明細", message,true,
          () => {
            this.messageDialog.visible = false
          },() => {})

    },
    showBankEditor(item) {
      this.bankDialog.visible = true

      this.bankItem = item
      const self = this
      this.bankDialog.confirm = (bankItemInfo) => {
        self.bankDialog.visible = false
        console.log(`bankItemInfo === ${JSON.stringify(bankItemInfo)} isNew === ${self.isNew}`)
        if (self.isNew) {
          self.createBank(bankItemInfo)
        } else {
          self.updateBank(bankItemInfo)
        }
        self.loadData();
      }
      this.bankDialog.cancel = () => {
        self.bankDialog.visible = false
      }
    },
    cellEvent(props) { // cell 按鈕事件 (用Key判斷是點選哪一個
      if (props.key === 'edit'){
        this.edit(props.item)
      }
      if (props.key === 'delete'){
        this.removeData(props.item)
      }
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    closeEvent() {
      this.items = []
      this.$emit('closeEvent');
    },
    confirmEvent(){
      this.$emit('closeEvent');
    },
    async removeData(data){
      this.messageDialog.showCancelButton = true
      let message = `是否刪除代號 ${data.title}-${data.subTitle}-${data.name} 的銀行資料？`
        this.showMessageDialog("提示",message,true,
          () => {
            this.messageDialog.visible = false
            this.messageDialog.showCancelButton = false
            const info = {'bankId': data.bankId}
            this.deleteEvent(info)
          }, () => {
            this.messageDialog.visible = false
            this.messageDialog.showCancelButton = false
        })
    },
    async deleteEvent(info){
      const results = await this.deleteBank(info)
      this.showMessageDialog("提示",results.data.message,true,
        () => {
          this.messageDialog.visible = false
        }, () => {
          this.messageDialog.visible = false
        })
      this.loadData();
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/BankManagerDialog.vue